import React, { Dispatch, SetStateAction, useEffect } from 'react'

import {
    HomeOutlined,
    QuestionCircleOutlined,
    MoneyCollectOutlined,
    StockOutlined,
    MinusSquareOutlined,
    UpSquareOutlined,
    DownSquareOutlined,
    SyncOutlined,
    EditOutlined
} from '@ant-design/icons';

import { Button, Empty, Popconfirm, Space, Table, message } from 'antd';
import { useApi } from '../../Utils';
import Column from 'antd/lib/table/Column';


// @ts-ignore
import { useSelector } from 'react-redux';

interface OrderRow {
    sku: string
    glosa?: string
    stockTotal: number
    fechaActualizacion: Date
    stockManager?: number
    stockTransit?: number
    // id: number
    // orderId: string
    // date: string
    // storeId: number
    // extras: string
    // paymentPeriod: number
    // created_at: string
    // updated_at?: string
    // dispatchCarrierName: string
    // dispatchCarrierCode: string
    // lastState: string | null
    // items: OrderRowItem[]
}

const ManualStock = ({ record, setMainLoading }: { record: OrderRow, setMainLoading: Dispatch<SetStateAction<boolean>> }) => {
    const { fetch, data, errors, loading } = useApi<any>('post', `v3/sync/stock/${record.sku}`, {
        onRequest: true,
        requiredToken: true
    })

    useEffect(() => {
        if (data) {
            if (data?.response[0]?.mensaje) {
                message.success(`${data.response[0].sku}: ${data.response[0].mensaje}`)
            }
            console.log(data)
        }
    }, [data])

    useEffect(() => {
        setMainLoading(loading)
    }, [loading, setMainLoading])

    useEffect(() => {
        if (errors?.length > 0) {
            console.log({ errors })
            for (const error of errors) {
                message.error(`Error: ${error.statusMessage}`)
            }
        }
    }, [errors])

    const showConfirm = () => {
        const _manualStock = prompt(`Modificación manual SKU ${record.sku}`, `${(record.stockManager || '')}`)
        const _manualStockNumber = Number(_manualStock)
        if (isFinite(_manualStockNumber) && !isNaN(_manualStockNumber)) {
            fetch({
                stock: _manualStockNumber,
                manual: true
            })
        } else {
            message.error(`Ingresa solo números.`)
        }
    }

    return (
        <div>
            <Button type="danger" onClick={showConfirm}>
                <EditOutlined />
            </Button>
        </div>
    );
};

const ButtonAction = ({ cta, record, setMainLoading }: { cta: string | undefined, record: OrderRow, setMainLoading: Dispatch<SetStateAction<boolean>> }) => {
    const { fetch, data, errors, loading } = useApi<any>('post', `v3/sync/stock/${record.sku}`, {
        onRequest: true,
        requiredToken: true
    })

    useEffect(() => {
        if (data) {
            if (data?.response[0]?.mensaje) {
                message.success(`${data.response[0].sku}: ${data.response[0].mensaje}`)
            }
            console.log(data)
        }
    }, [data])

    useEffect(() => {
        setMainLoading(loading)
    }, [loading, setMainLoading])

    useEffect(() => {
        if (errors?.length > 0) {
            console.log({ errors })
            for (const error of errors) {
                message.error(`Error: ${error.statusMessage}`)
            }
        }
    }, [errors])

    return <Popconfirm
        // disabled={['Despachado', 'PickingParcialAnulado'].includes(`${record.lastState}`)}
        title={`¿Estás seguro de sincronizar stock para el SKU ${record.sku}?`}
        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
        placement='left'
        onConfirm={() => {
            // const _next = nextState.get(cta ?? 'Liberar')
            fetch({
                stock: record.stockManager,
                manual: false
            })
        }}
        onCancel={() => {
            //
        }}
        okType={'danger'}
        okText='Si'
        cancelText='No'
    >
        <Button
            size='small'
            style={{
                minWidth: 96,
                textAlign: 'left'
            }}
            type={'primary'}
            icon={<SyncOutlined />}
            
            loading={loading}
        >
            {cta}
        </Button>
    </Popconfirm>
}

export default function SyncStock({ isMobile, exposeSubMenu, setMainLoading }: any) {
    const { data, loading } = useApi<any>('get', 'v3/sync/stocks')
    const [records, setRecords] = React.useState<OrderRow[]>([])
    const { permissions } = useSelector((state: any) => state)


    useEffect(() => {
        if (data?.status === 'success') {
            setRecords(data.stocks)
            // setRecords(data.orders)
            // console.log(data.orders)
        }
    }, [data])

    useEffect(() => {
        if (!!exposeSubMenu) {
            const _submenu = [
                { key: 'index', name: 'Papel de Trabajo', icon: <HomeOutlined /> },
            ]

            if (permissions.includes('FacturacionMensual')) {
                _submenu.push({ key: 'emission', name: 'Facturación mensual', icon: <MoneyCollectOutlined /> },)
            }

            if (permissions.includes('WebStock')) {
                _submenu.push({ key: 'sync-stock', name: 'Stock en Web', icon: <StockOutlined /> },)
                _submenu.push({ key: 'historiales-stock', name: 'Historiales', icon: <StockOutlined /> },)
            }

            exposeSubMenu(_submenu)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exposeSubMenu])

    useEffect(() => {
        setMainLoading(false)
    }, [setMainLoading])

    
    return (
        <div className="App">
            <div className="Orders">
                <div className="Wrapper">
                    <Table
                        dataSource={records}
                        loading={loading}
                        pagination={false}
                        rowKey={(record) => `Row${record.sku}`}
                        className='TableListAll'
                        size='small'
                        locale={{
                            emptyText: (
                                <Empty
                                    style={{ marginTop: '32px', marginBottom: '48px' }}
                                    description='No se han encontrado productos con los criterios de bùsqueda.'
                                >
                                </Empty>
                            )
                        }}
                        footer={() => <>Total de productos {records.length}</>}
                    >
                        <Column
                            title='SKU'
                            dataIndex='sku'
                            key='sku'
                            sortDirections={['descend', 'ascend']}
                            sorter={(a: any, b: any) => a.sku.localeCompare(b.sku)}
                            filters={records.map(r => {
                                const i = {
                                    text: r.sku,
                                    value: r.sku
                                }
                                return i
                            })}
                            filterSearch={true}
                            onFilter={(value, record) => {
                                return record.sku.toLowerCase().includes(`${value}`.toLowerCase())
                            }}
                            // onFilter={(value: string, record: any) => record.name.indexOf(value) === 0}
                        />
                        <Column
                            title='Glosa'
                            dataIndex='glosa'
                            key='glosa'
                            sortDirections={['descend', 'ascend']}
                            sorter={(a: any, b: any) => a.glosa?.localeCompare(b.glosa)}
                        />
                        <Column
                            title='Fecha última carga'
                            dataIndex='fechaActualizacion'
                            key='fechaActualizacion'
                            sortDirections={['descend', 'ascend']}
                            sorter={(a: any, b: any) => a.fechaActualizacion.localeCompare(b.fechaActualizacion)}
                        />
                        {/* <Column
                            title='Estado'
                            dataIndex='lastState'
                            key='lastState'
                            filters={[
                                { text: 'Por liberar', value: '' },
                                { text: 'En preparación', value: 'EnPreparacion' },
                                { text: 'Anulado', value: 'PickingParcialAnulado' },
                                { text: 'Pickeado', value: 'Picking' },
                                { text: 'Despachado', value: 'Despachado' },
                            ]}
                            defaultFilteredValue={['', 'EnPreparacion', 'Picking']}
                            onFilter={(value, record: any) => {
                                if (value === '') {
                                    return record.lastState === null
                                }
                                if (value === 'Anulado') {
                                    return record.lastState === 'PickingParcialAnulado'
                                }
                                if (value === 'Picking') {
                                    return record.lastState === 'PickingParcialCompletado' || record.lastState === 'PickingCompleto'
                                }

                                return record.lastState?.indexOf(value) > -1
                            }}
                            render={(value) => {
                                switch (value) {
                                    case 'EnPreparacion':
                                        return <>En preparación</>
                                    case 'PickingParcialCompletado':
                                    case 'PickingCompleto':
                                        return <>Pickeado {value === 'PickingParcialCompletado' && <>(parcial)</>}</>
                                    case 'PickingParcialAnulado':
                                        return <>Anulado</>
                                    case 'Despachado':
                                        return <>Despachado</>
                                    default:
                                        return <>Por liberar</>
                                }
                            }}
                        /> */}
                        {/* <Column
                            title='Referencias'
                            key='products'
                            render={(value, record: OrderRow) => {
                                return <>{record.items.length}</>
                            }}
                        /> */}
                        <Column
                            title='Publicado'
                            key='stockTotal'
                            dataIndex='stockTotal'
                            render={(value, record: OrderRow) => {
                                const diff = (((record.stockManager || 0) + (record.stockTransit || 0)) - record.stockTotal)
                                const sign = diff === 0 ? <MinusSquareOutlined style={{color:'green'}} /> : diff > 0 ? <UpSquareOutlined style={{color:'red'}} /> : <DownSquareOutlined style={{color:'orange'}} />
                                
                                return <>
                                    {sign} {value}
                                </>
                            }}
                        />
                        <Column
                            title='Manager'
                            key='stockManager'
                            dataIndex='stockManager'
                            render={(value, record: OrderRow) => {
                                return <>{value} {record.stockTransit && <sup>+ {record.stockTransit}</sup>}</>
                            }}
                        />
                        <Column
                            title='Acciones'
                            key='action'
                            render={(text, record: OrderRow) => {
                                return <Space size='small'>
                                    <Button.Group size='small'>
                                        <ButtonAction
                                            cta={`Sync`}
                                            record={record}
                                            setMainLoading={setMainLoading}
                                            key={`SyncStk${record.sku}`}
                                        />
                                        <ManualStock record={record} setMainLoading={setMainLoading} key={`ManualStk${record.sku}`} />
                                    </Button.Group>
                                </Space>
                            }}
                        />
                    </Table>
                </div>
            </div>
        </div>
    )
}
